import { render } from "./device_controllers.vue?vue&type=template&id=a52201b8&scoped=true"
import script from "./device_controllers.js?vue&type=script&lang=js"
export * from "./device_controllers.js?vue&type=script&lang=js"

import "./device_controllers.vue?vue&type=style&index=0&id=a52201b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52201b8"]])

export default __exports__